import { useCallback, useEffect, useState } from "react";
import { RefreshCw, X } from "lucide-react";

// „Neue Version verfügbar“: vergleicht die eingebaute Build-Version mit /version.json (vom Server, no-cache).
// Ohne REACT_APP_VERSION (lokale Entwicklung) inaktiv.
const RUNNING = process.env.REACT_APP_VERSION || "";
const INTERVAL_MS = 5 * 60 * 1000;

async function fetchServerVersion() {
  const r = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
  if (!r.ok) return "";
  return String((await r.json())?.version || "");
}

export default function VersionCheck() {
  const [neu, setNeu] = useState(false);
  const [hidden, setHidden] = useState(false);

  const check = useCallback(async () => {
    try {
      const v = await fetchServerVersion();
      if (v && v !== RUNNING) setNeu(true);
    } catch { /* offline o. Ä. – beim nächsten Mal erneut */ }
  }, []);

  useEffect(() => {
    if (!RUNNING) return undefined;
    check();
    const id = setInterval(check, INTERVAL_MS);
    const onVisible = () => { if (document.visibilityState === "visible") check(); };
    window.addEventListener("focus", check);
    document.addEventListener("visibilitychange", onVisible);
    return () => { clearInterval(id); window.removeEventListener("focus", check); document.removeEventListener("visibilitychange", onVisible); };
  }, [check]);

  if (!neu || hidden) return null;
  return (
    <div role="status" className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-3 rounded-lg bg-slate-900 text-white shadow-xl px-4 py-3 text-sm" data-testid="new-version-banner">
      <span>Neue Version verfügbar</span>
      <button type="button" onClick={() => window.location.reload()} className="inline-flex items-center gap-1.5 rounded-md bg-blue-600 hover:bg-blue-500 px-3 py-1.5 font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-testid="new-version-reload-button">
        <RefreshCw className="w-4 h-4" /> Neu laden
      </button>
      <button type="button" onClick={() => setHidden(true)} aria-label="Hinweis schließen" className="rounded p-1 text-slate-300 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-testid="new-version-dismiss-button">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
